export const CATALOG      = 'catalog'
export const CATALOG_PATH = '/catalog'

export const POSTS_PATH = '/posts'
export const POSTS = 'posts'
